<template>
  <div class="encabezado-modal">
    <v-icon v-if="icono" color="white" size="28" class="mr-3">{{ icono }}</v-icon>
    <div class="encabezado-modal__titulo">
      <strong>{{ titulo }}</strong>
      <small v-if="subtitulo">{{ subtitulo }}</small>
    </div>
    <v-spacer></v-spacer>
    <slot></slot>
    <v-btn v-if="cerrable" icon color="white" title="Cerrar" @click="$emit('cerrar')"><v-icon>mdi-close</v-icon></v-btn>
  </div>
</template>

<script>
/** Encabezado azul de los modales del POS (el mismo de «Activar tarjeta»). Los estilos están en App.vue (.encabezado-modal). */
export default {
  name: "EncabezadoModal",
  props: {
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: "" },
    icono: { type: String, default: "" },
    cerrable: { type: Boolean, default: true },
  },
};
</script>
